/**
 * @generated SignedSource<<13e74e601b3b906ab8b26d7449ea5fe5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipativeModuleResultsFormFieldContainer_result",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answersCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "participationRatio",
      "storageKey": null
    }
  ],
  "type": "ParticipativeModuleResultsFormField",
  "abstractKey": "__isParticipativeModuleResultsFormField"
};

node.hash = "852d25a655d26967b287ca160fd0186a";

module.exports = node;
